import { render, staticRenderFns } from "./IllustrationsPage.vue?vue&type=template&id=78ffb3f6&scoped=true&"
var script = {}
import style0 from "./IllustrationsPage.vue?vue&type=style&index=0&id=78ffb3f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ffb3f6",
  null
  
)

export default component.exports